module.exports = __webpack_public_path__ + "img/task_send.25a94143.svg";